import React from 'react'
import { Link } from "react-router-dom";
import { Image } from "react-bootstrap";
import MiniBtnAddToCart from "../layout/Buttons/MiniBtn-Add-To-Cart";
import {
  formatCompareValue,
  getProductImageUrl,
} from "../../utils/productCompare";
import { formatThousandsNumber } from "../../utils/numberFormat";

/**
 * 渲染商品 Datasheet 链接，未上传时显示占位符。
 * @param {{ datasheet?: string }} product 商品对象
 * @returns {React.JSX.Element} Datasheet 单元格内容
 */
const renderDatasheetCell = (product) => {
  if (!product?.datasheet) {
    return <span>-</span>
  }

  return (
    <a
      href={product.datasheet}
      target="_blank"
      rel="noreferrer"
      className="text-blue-600 underline"
    >
      PDF
    </a>
  )
}

/**
 * 格式化商品动态属性值，空值统一显示占位符。
 * @param {any} value 商品属性值
 * @returns {string} 可展示的属性值
 */
/**
 * 格式化商品列表价格，统一显示为 $ xxx。
 * @param {number|string} price 商品价格
 * @returns {string} 可展示的价格文本
 */
const formatProductPrice = (price) => {
  if (price === undefined || price === null || price === "") {
    return "$ 0"
  }

  return `$ ${price}`
}

/**
 * 渲染商品表格行中的商品信息与动态属性单元格。
 * @param {{ product?: Record<string, any>, attributeKeys?: string[], isSelected?: boolean, onToggleCompare?: (product: Record<string, any>) => void }} props 组件属性
 * @returns {React.JSX.Element} 商品表格行片段
 */
const ProductItem = ({product, attributeKeys = [], isSelected = false, onToggleCompare}) => {
      return (
        <>
          <td className="sticky left-0 z-20 bg-inherit border-r-2 border-r-gray-400/20 p-1 md:p-3 text-center">
            <input
              type="checkbox"
              checked={isSelected}
              onChange={() => onToggleCompare?.(product)}
              aria-label={`Compare ${product?.name || "product"}`}
              className="h-4 w-4 cursor-pointer accent-[#2684fe]"
            />
          </td>
          <td className="sticky md:static left-[42px] z-10 bg-inherit border-l-0 border-r-2 border-r-gray-400/20 p-1 md:p-3 shadow-[2px_0_5px_-2px_rgba(0,0,0,0.1)] md:shadow-none">
            <figure className="flex flex-col items-center gap-1 md:flex-row md:gap-3">
              <div className="w-[50px] md:w-[100px] shrink-0">
                <Image
                  src={getProductImageUrl(product)}
                  alt={product?.name}
                  loading="lazy"
                  className="w-full h-auto rounded-lg"
                />
              </div>
              <figcaption className="min-w-0 flex-1 max-w-[80px] text-center md:max-w-[220px] md:text-left">
                <Link
                  className="block truncate text-[10px] font-bold text-gray-800 transition-colors duration-300 ease-in-out hover:text-orange-400 md:text-sm"
                  to={`/products/${product?._id}`}
                >
                  {product?.name}
                </Link>
                {product?.description && (
                  <p
                    className="mt-1 block truncate text-[9px] font-normal text-gray-500 md:text-xs"
                    title={product.description}
                  >
                    {product.description}
                  </p>
                )}
              </figcaption>
            </figure>
          </td>
          <td className="border-r-2 border-r-gray-400/20 p-1 md:p-3 text-[10px] md:text-sm text-center font-bold text-gray-800">
            {renderDatasheetCell(product)}
          </td>
          <td className="transition-colors duration-300 ease-in-out hover:text-orange-400 border-r-2 border-r-gray-400/20 p-1 md:p-3 text-[10px] md:text-sm text-center font-bold text-gray-800">
            <Link to={`/products/${product?._id}`}>
              {product?.Manufacturer}
            </Link>
          </td>
          <td className="transition-colors duration-300 ease-in-out hover:text-orange-400 border-r-2 border-r-gray-400/20 p-1 md:p-3 text-[10px] md:text-sm text-center font-bold text-gray-800">
            <Link to={`/products/${product?._id}`}>{formatThousandsNumber(product?.stock)}</Link>
          </td>
          <td className="min-w-[100px] whitespace-nowrap transition-colors duration-300 ease-in-out hover:text-orange-400 border-r-2 border-r-gray-400/20 p-1 md:p-3 text-[10px] md:text-sm text-center font-bold text-gray-800">
            <Link to={`/products/${product?._id}`}>{formatProductPrice(product?.price)}</Link>
          </td>
          <td className="border-r-2 border-r-gray-400/20 p-1 md:p-3 text-center min-w-[130px]">
            <div className="flex items-center justify-center w-full bg-inherit">
              <MiniBtnAddToCart {...product} />
            </div>
          </td>
          <td className="transition-colors duration-300 ease-in-out hover:text-orange-400 border-r-2 border-r-gray-400/20 p-1 md:p-3 text-[10px] md:text-sm text-center font-bold text-gray-800">
            <Link to={`/products/${product?._id}`}>
              {product?.CTYEA_Part_Number}
            </Link>
          </td>
          {attributeKeys.map((key) => {
            const value = formatCompareValue(product?.product_Attributes?.[key])

            return (
              <td
                key={key}
                className="transition-colors duration-300 ease-in-out hover:text-orange-400 border-r-2 border-r-gray-400/20 p-1 md:p-3 text-[10px] md:text-sm text-center font-bold text-gray-800 min-w-[140px] max-w-[220px]"
                title={value}
              >
                <span className="block truncate">{value}</span>
              </td>
            )
          })}
        </>
      );
}

export default ProductItem
